import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TranslatePipe } from '@ngx-translate/core';
import { get } from 'lodash';
import { FormGroupComponent } from '../../../../forms';
import { FilterFieldOptions } from '../../../models';
import { FilterTreeFieldComponent } from '../filter-tree-field/filter-tree-field.component';

@Component({
  selector: 'iot-platform-ui-filter-set-field',
  standalone: true,
  imports: [FormGroupComponent, MatTreeModule, MatCheckboxModule, MatButtonModule, MatIconModule, MatTooltipModule, TranslatePipe],
  templateUrl: './filter-set-field.component.html',
  styleUrl: '../filter-tree-field/filter-tree-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterSetFieldComponent extends FilterTreeFieldComponent {
  fieldOptions: Signal<Partial<FilterFieldOptions>> = computed(() => {
    const field = this.field();
    const options = field?.options;
    let filterBy = get(options, 'filterBy', 'value');
    const selectByProperty = get(options, 'selectByProperty', filterBy);
    if (options?.list) {
      filterBy = get(options, 'filterBy', 'key');
      // by default use 'key' and 'value' properties for static lists
      options.filterBy = filterBy;
      options.selectByProperty = get(options, 'selectByProperty', 'value');
      options.labelToDisplay = get(options, 'labelToDisplay', 'value');
      options.treeIdProperty = get(options, 'treeIdProperty', filterBy);
      options.treeParentProperty = null;
      return options;
    }
    return {
      ...options,
      filterBy,
      selectByProperty,
      labelToDisplay: get(options, 'labelToDisplay', get(options, 'selectByProperty', 'key')),
      treeIdProperty: get(options, 'treeIdProperty', filterBy),
      treeParentProperty: null
    };
  });
}
